<template>
  <v-container id="paymentmades" fluid tag="section">
    <v-row justify="center" class="randomNumber">
      <v-btn-toggle rounded style="float: left; background: transparent" v-if="pendingBUWise">
        <v-btn v-for="(value, name) in pendingBUWise" :key="'pendingBUWise.' + name" small :color="'grey'">
          <h3 style="padding-right: 50px">
            <div style="width: 20px; height: 12px; float: left"></div>
            <v-badge color="pink" :content="value" :value="name">{{
              name
            }}</v-badge>
          </h3>
        </v-btn>
      </v-btn-toggle>
      <div>
        <v-btn color="cyan" @click="showFilter = !showFilter" small>
          <v-icon>mdi-filter</v-icon>
        </v-btn>
      </div>
    </v-row>
    <v-row justify="center" v-if="showFilter">
      <v-col cols="12" md="12">
        <base-material-card color="light-blue" icon="mdi-filter" class="px-3 py-1 small-icon" v-if="showFilter">
          <div class="filter-close">
            <v-btn color="black" class="mr-0" fab small text @click="showFilter = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-row>
            <v-col cols="12" sm="3" md="2" lg="2">
              <z-date-picker label="Start Date" class="purple-input" v-model="filter.startDate" />
            </v-col>
            <v-col cols="12" sm="3" md="2" lg="2">
              <z-date-picker label="End Date" class="purple-input" v-model="filter.endDate" />
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="3">
              <z-entity-select withSelf corp="self" clearable v-model="filter.entity_id" label="Serving Entity" />
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="3">
              <z-vendor-select withSelf clearable v-model="filter.vendor_id" />
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="2">
              <v-text-field :label="$i18n.t('Sequence No.')" v-model="filter.seqNo" clearable />
            </v-col>
            <v-col cols="12" sm="12" md="3" lg="2">
              <v-text-field :label="$i18n.t('Reference No.')" v-model="filter.refNo" clearable />
            </v-col>

            <v-col cols="12" sm="12" md="3" lg="2" class="text-right">
              <v-btn color="cyan" class="mr-0" fab small dark @click="download()" :loading="loading">
                <v-icon>mdi-cloud-download-outline</v-icon>
              </v-btn>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn class="mr-0" color="grey darken" fab text small @click="clear(1)"
                    style="margin-right: 10px !important" v-on="on">
                    <v-icon>mdi-cached</v-icon>
                  </v-btn>
                </template>
                <span>{{ $i18n.t("Clear Filter") }}</span>
              </v-tooltip>
              <v-btn color="success" class="mr-0" fab small dark @click="search()" :loading="loading">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </base-material-card>
      </v-col>
    </v-row>
    <v-btn v-if="records.length == 0" class="text-center secondary--text pa-10" text color="primary" style="width: 100%"
      :loading="loading">{{ $i18n.t("No records available") }}</v-btn>

    <base-material-card icon="mdi-card-text-outline" :title="$i18n.t('Payments Pending')" class="px-5 py-3 small-icon"
      v-if="records">
      <payment-pending-row v-for="item in records" :key="item._id" :value="item" @reload="reload" :refresh="refresh" />
    </base-material-card>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doGetWithDownload } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import PaymentPendingRow from "@/views/paymentpending/PaymentPendingRow.vue";

@Component({
  name: "PaymentPending",
  components: { PaymentPendingRow },
})
export default class PaymentPending extends Vue {
  records = [];
  url = "/api/paymentmade/pending/grid?&";
  showFilter = false;
  filterUrl = "";
  on = null;
  pendingBUWise = null;

  filter = {
    startDate: null,
    endDate: null,
    seqNo: null,
    refNo: null,
    vendor_id: null,
    entity_id: null,
  };

  get loading() {
    return common.loading;
  }

  async mounted() {
    this.showPage(1);
    this.fetchPendingBuWise();
  }

  async fetchPendingBuWise() {
    const url = "/api/paymentmade/pending/entity/stats";
    try {
      this.pendingBUWise = await doGet(url);
    } catch (e) {
      common.setError(e.message);
    }
  }

  async download() {
    const url = "/api/paymentmade/pending/download?&";
    try {
      common.setLoading(true);
      await doGetWithDownload(url);
      common.setLoading(false);
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async showPage() {
    common.setLoading(true);
    try {
      const grid = await doGet(this.url + this.filterUrl);
      this.records = grid;
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async clear() {
    this.filter = {
      startDate: null,
      endDate: null,
      seqNo: null,
      refNo: null,
      vendor_id: null,
    };

    this.search();
  }

  async refresh(__i) {
    if (__i == 1) {
      this.search();
    }
  }

  getFilterUrl() {
    let filterUrl = "";
    if (this.filter.startDate)
      filterUrl += "&startDate=" + this.filter.startDate;
    if (this.filter.endDate) filterUrl += "&endDate=" + this.filter.endDate;
    if (this.filter.seqNo) filterUrl += "&seqNo=" + this.filter.seqNo;
    if (this.filter.refNo) filterUrl += "&refNo=" + this.filter.refNo;
    if (this.filter.entity_id)
      filterUrl += "&entity_id=" + this.filter.entity_id;
    if (this.filter.vendor_id)
      filterUrl += "&vendor_id=" + this.filter.vendor_id;
    return filterUrl;
  }

  async search() {
    this.filterUrl = this.getFilterUrl();
    common.setLoading(true);
    await this.showPage();
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  async reload() {
    this.showPage(this.page);
    this.fetchPendingBuWise();
  }
}
</script>

<style scoped>
.filter-close {
  position: absolute;
  right: 5px;
  top: 5px;
}

.dialog {
  position: fixed;
  top: 100px;
  width: 60%;
  z-index: 10;
  margin-left: 15%;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  background-color: white;
  border-top: 1px solid #dfdfdf;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 2;
}

.randomNumber {
  display: flex !important;
  justify-content: space-between !important;
}
</style>
